import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { footer } from "./drawer.module.scss";

const Footer = ({ className, ...props }) => (
  <footer className={classNames(footer, "p-4", className)} {...props} />
);

Footer.propTypes = {
  className: PropTypes.string
};

Footer.defaultProps = {
  className: ""
};

export default Footer;
